// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__CBImR","content":"LayoutSettings_content__2r_j-"};